/* eslint-disable no-nested-ternary */
import React, { PropTypes } from 'react';
import { provideContext } from 'fluxible-addons-react';
import { Modal } from '../Modal';
import { withStyle } from '../../utils/Decorator';

@provideContext({ insertCss: PropTypes.func.isRequired })
@withStyle(require('../Modal/Modal.styl'), require('./ModalResult.styl'))
export default class ModalResult extends Modal {
  static displayName='ModalResult';

  isLoaded = () => true;

  renderContent = () => (
    <div className='ModalResult'>
      <div className='ModalHead'>
        全国書店白書
      </div>
      <div className='ModalBody size-none'>
        {this.isLoaded() && (
          <div>
            <div className='description'>
              <p>2017年1月8日(日)を持ちまして、みんストは正式サービス開始より14日を迎え、終了しました。</p>
              <p>2週間で全国の書店がどのような成長を遂げたのか分析しました。どうぞご覧ください。</p>
            </div>

            <div className='full-label'>
              <div className='label'>書店統計</div>
              <div className='results'>
                <div className='result'>
                  <div className='title'>全国書店数</div>
                  <div className='value'>32,095店</div>
                </div>
                <div className='result'>
                  <div className='title'>全国書店員数</div>
                  <div className='value'>191,730人</div>
                </div>
                <div className='result'>
                  <div className='title'>全国総来客者数</div>
                  <div className='value'>6,122,242人</div>
                </div>
                <div className='result'>
                  <div className='title'>全国総シェア数</div>
                  <div className='value'>167,809回</div>
                </div>
                <div className='result'>
                  <div className='title'>全国総売上</div>
                  <div className='value gold'>668,278,636,629,203G</div>
                </div>
                <div className='result'>
                  <div className='title'>全国総冊数</div>
                  <div className='value'>2,051,786冊</div>
                </div>
                <div className='result'>
                  <div className='title'>全国絶対に押してはいけないボタンを<br />押しちゃった総数</div>
                  <div className='value'>305,701回</div>
                </div>
              </div>
            </div>

            {/*
              <div className='full-label'>
                <div className='label'>採用された書店員BEST20</div>
                <div className='ranks'>
                  <div className='rank first' data-rank='1'>
                    <div className='icon' style={{ backgroundImage: 'url(https://pbs.twimg.com/profile_images/510260901471989760/7pxKCNa1.png)' }} />
                    <div className='info'>
                      <div className='name'>「刀剣乱舞」開発・運営</div>
                      <div className='book'>1,056店</div>
                    </div>
                  </div>
                  <div className='rank second' data-rank='2'>
                    <div className='icon' style={{ backgroundImage: 'url(https://pbs.twimg.com/profile_images/644866996299919360/9wrB2Yu3.jpg)' }} />
                    <div className='info'>
                      <div className='name'>刀剣乱舞-本丸通信-【公式】</div>
                      <div className='book'>689店</div>
                    </div>
                  </div>
                </div>
              </div>
            */}

            <div className='full-label'>
              <div className='label'>獲得困難だったトロフィーBEST5</div>
              <div className='ranks'>
                <div className='rank first' data-rank='1'>
                  <div className='icon' style={{ backgroundImage: 'url("/images/trophy.png")' }} />
                  <div className='info'>
                    <div className='trophy-name'>言い値で買おう！</div>
                    <div className='trophy-desc'>最大瞬間売上100,000,000を計測</div>
                    <div className='trophy-data'>133店（全体の0.41%）</div>
                  </div>
                </div>
                <div className='rank second' data-rank='2'>
                  <div className='icon' style={{ backgroundImage: 'url("/images/trophy.png")' }} />
                  <div className='info'>
                    <div className='trophy-name'>Congratulation！</div>
                    <div className='trophy-desc'>新井式回転抽選器で1等を当てた</div>
                    <div className='trophy-data'>390店（全体の1.21%）</div>
                  </div>
                </div>
                <div className='rank third' data-rank='3'>
                  <div className='icon' style={{ backgroundImage: 'url("/images/trophy.png")' }} />
                  <div className='info'>
                    <div className='trophy-name'>知られざる本達の楽園</div>
                    <div className='trophy-desc'>全ての本棚のレベルを最大まで育てた</div>
                    <div className='trophy-data'>738店（全体の2.30%）</div>
                  </div>
                </div>
                <div className='rank' data-rank='4'>
                  <div className='icon' style={{ backgroundImage: 'url("/images/trophy.png")' }} />
                  <div className='info'>
                    <div className='trophy-name'>幸せを呼ぶ蒼い鳥</div>
                    <div className='trophy-desc'>Twitterシェアを50回した</div>
                    <div className='trophy-data'>746店（全体の2.32%）</div>
                  </div>
                </div>
                <div className='rank' data-rank='5'>
                  <div className='icon' style={{ backgroundImage: 'url("/images/trophy.png")' }} />
                  <div className='info'>
                    <div className='trophy-name'>pixivコミックを読みたいだけの人生じゃった・・・</div>
                    <div className='trophy-desc'>pixivコミックでマンガを70冊よんでボタンをおした</div>
                    <div className='trophy-data'>803店（全体の2.50%）</div>
                  </div>
                </div>
              </div>
            </div>

            <div className='full-label'>
              <div className='label'>ツイートした数</div>
              <div className='wrap'>
                <div className='cell head'>
                  <div className='td'>回数</div>
                  <div className='td'>店長数</div>
                </div>
                <div className='cell body'>
                  <div className='td'>5000</div>
                  <div className='td'>1（全体の0.01%）</div>
                </div>
                <div className='cell body'>
                  <div className='td'>900</div>
                  <div className='td'>1（全体の0.01%）</div>
                </div>
                <div className='cell body'>
                  <div className='td'>700</div>
                  <div className='td'>1（全体の0.01%）</div>
                </div>
                <div className='cell body'>
                  <div className='td'>600</div>
                  <div className='td'>2（全体の0.01%）</div>
                </div>
                <div className='cell body'>
                  <div className='td'>500</div>
                  <div className='td'>4（全体の0.03%）</div>
                </div>
                <div className='cell body'>
                  <div className='td'>400</div>
                  <div className='td'>5（全体の0.03%）</div>
                </div>
                <div className='cell body'>
                  <div className='td'>300</div>
                  <div className='td'>10（全体の0.07%）</div>
                </div>
                <div className='cell body'>
                  <div className='td'>200</div>
                  <div className='td'>33（全体の0.23%）</div>
                </div>
                <div className='cell body'>
                  <div className='td'>100</div>
                  <div className='td'>204（全体の1.40%）</div>
                </div>
                <div className='cell body'>
                  <div className='td'>90</div>
                  <div className='td'>32（全体の0.22%）</div>
                </div>
                <div className='cell body'>
                  <div className='td'>80</div>
                  <div className='td'>57（全体の0.39%）</div>
                </div>
                <div className='cell body'>
                  <div className='td'>70</div>
                  <div className='td'>84（全体の0.57%）</div>
                </div>
                <div className='cell body'>
                  <div className='td'>60</div>
                  <div className='td'>101（全体の0.69%）</div>
                </div>
                <div className='cell body'>
                  <div className='td'>50</div>
                  <div className='td'>210（全体の1.44%）</div>
                </div>
                <div className='cell body'>
                  <div className='td'>40</div>
                  <div className='td'>170（全体の1.16%）</div>
                </div>
                <div className='cell body'>
                  <div className='td'>30</div>
                  <div className='td'>298（全体の2.04%）</div>
                </div>
                <div className='cell body'>
                  <div className='td'>20</div>
                  <div className='td'>564（全体の3.86%）</div>
                </div>
                <div className='cell body'>
                  <div className='td'>10</div>
                  <div className='td'>1725（全体の11.81%）</div>
                </div>
                <div className='cell body'>
                  <div className='td'>9</div>
                  <div className='td'>232（全体の1.59%）</div>
                </div>
                <div className='cell body'>
                  <div className='td'>8</div>
                  <div className='td'>257（全体の1.76%）</div>
                </div>
                <div className='cell body'>
                  <div className='td'>7</div>
                  <div className='td'>800（全体の5.48%）</div>
                </div>
                <div className='cell body'>
                  <div className='td'>6</div>
                  <div className='td'>386（全体の2.64%）</div>
                </div>
                <div className='cell body'>
                  <div className='td'>7</div>
                  <div className='td'>355（全体の2.43%）</div>
                </div>
                <div className='cell body'>
                  <div className='td'>6</div>
                  <div className='td'>386（全体の2.64%）</div>
                </div>
                <div className='cell body'>
                  <div className='td'>5</div>
                  <div className='td'>568（全体の3.89%）</div>
                </div>
                <div className='cell body'>
                  <div className='td'>4</div>
                  <div className='td'>800（全体の5.48%）</div>
                </div>
                <div className='cell body'>
                  <div className='td'>3</div>
                  <div className='td'>1358（全体の9.30%）</div>
                </div>
                <div className='cell body'>
                  <div className='td'>2</div>
                  <div className='td'>1881（全体の12.88%）</div>
                </div>
                <div className='cell body'>
                  <div className='td'>1</div>
                  <div className='td'>5269（全体の36.07%）</div>
                </div>
              </div>
            </div>

            <div className='full-label'>
              <div className='label'>マンガの入荷冊数</div>
              <div className='wrap'>
                <div className='cell head'>
                  <div className='td'>冊数</div>
                  <div className='td'>店長数</div>
                </div>
                <div className='cell body'>
                  <div className='td'>1800</div>
                  <div className='td'>31（全体の0.12%）</div>
                </div>
                <div className='cell body'>
                  <div className='td'>1700</div>
                  <div className='td'>5（全体の0.02%）</div>
                </div>
                <div className='cell body'>
                  <div className='td'>1600</div>
                  <div className='td'>2（全体の0.01%）</div>
                </div>
                <div className='cell body'>
                  <div className='td'>1500</div>
                  <div className='td'>2（全体の0.01%）</div>
                </div>
                <div className='cell body'>
                  <div className='td'>1400</div>
                  <div className='td'>6（全体の0.02%）</div>
                </div>
                <div className='cell body'>
                  <div className='td'>1300</div>
                  <div className='td'>9（全体の0.03%）</div>
                </div>
                <div className='cell body'>
                  <div className='td'>1200</div>
                  <div className='td'>7（全体の0.03%）</div>
                </div>
                <div className='cell body'>
                  <div className='td'>1100</div>
                  <div className='td'>9（全体の0.03%）</div>
                </div>
                <div className='cell body'>
                  <div className='td'>1000</div>
                  <div className='td'>25（全体の0.10%）</div>
                </div>
                <div className='cell body'>
                  <div className='td'>900</div>
                  <div className='td'>14（全体の0.05%）</div>
                </div>
                <div className='cell body'>
                  <div className='td'>800</div>
                  <div className='td'>24（全体の0.09%）</div>
                </div>
                <div className='cell body'>
                  <div className='td'>700</div>
                  <div className='td'>37（全体の0.14%）</div>
                </div>
                <div className='cell body'>
                  <div className='td'>600</div>
                  <div className='td'>49（全体の0.19%）</div>
                </div>
                <div className='cell body'>
                  <div className='td'>500</div>
                  <div className='td'>113（全体の0.44%）</div>
                </div>
                <div className='cell body'>
                  <div className='td'>400</div>
                  <div className='td'>238（全体の0.92%）</div>
                </div>
                <div className='cell body'>
                  <div className='td'>300</div>
                  <div className='td'>563（全体の2.18%）</div>
                </div>
                <div className='cell body'>
                  <div className='td'>200</div>
                  <div className='td'>2595（全体の10.03%）</div>
                </div>
                <div className='cell body'>
                  <div className='td'>100</div>
                  <div className='td'>3266（全体の12.62%）</div>
                </div>
                <div className='cell body'>
                  <div className='td'>50</div>
                  <div className='td'>2976（全体の11.50%）</div>
                </div>
                <div className='cell body'>
                  <div className='td'>1</div>
                  <div className='td'>15904（全体の61.46%）</div>
                </div>
              </div>
            </div>

            <div className='full-label'>
              <div className='label'>マンガの読了数</div>
              <div className='wrap'>
                <div className='cell head'>
                  <div className='td'>読了数</div>
                  <div className='td'>店長数</div>
                </div>
                <div className='cell body'>
                  <div className='td'>700-799</div>
                  <div className='td'>2（全体の0.03%）</div>
                </div>
                <div className='cell body'>
                  <div className='td'>500-599</div>
                  <div className='td'>3（全体の0.05%）</div>
                </div>
                <div className='cell body'>
                  <div className='td'>400-499</div>
                  <div className='td'>4（全体の0.06%）</div>
                </div>
                <div className='cell body'>
                  <div className='td'>300-399</div>
                  <div className='td'>8（全体の0.13%）</div>
                </div>
                <div className='cell body'>
                  <div className='td'>200-299</div>
                  <div className='td'>61（全体の0.98%）</div>
                </div>
                <div className='cell body'>
                  <div className='td'>100-199</div>
                  <div className='td'>389（全体の6.28%）</div>
                </div>
                <div className='cell body'>
                  <div className='td'>90-99</div>
                  <div className='td'>77（全体の1.24%）</div>
                </div>
                <div className='cell body'>
                  <div className='td'>80-89</div>
                  <div className='td'>69（全体の1.11%）</div>
                </div>
                <div className='cell body'>
                  <div className='td'>70-79</div>
                  <div className='td'>192（全体の3.10%）</div>
                </div>
                <div className='cell body'>
                  <div className='td'>60-69</div>
                  <div className='td'>125（全体の2.02%）</div>
                </div>
                <div className='cell body'>
                  <div className='td'>50-59</div>
                  <div className='td'>224（全体の3.61%）</div>
                </div>
                <div className='cell body'>
                  <div className='td'>40-49</div>
                  <div className='td'>183（全体の2.95%）</div>
                </div>
                <div className='cell body'>
                  <div className='td'>30-39</div>
                  <div className='td'>338（全体の5.45%）</div>
                </div>
                <div className='cell body'>
                  <div className='td'>20-29</div>
                  <div className='td'>491（全体の7.92%）</div>
                </div>
                <div className='cell body'>
                  <div className='td'>10-19</div>
                  <div className='td'>1175（全体の18.95%）</div>
                </div>
                <div className='cell body'>
                  <div className='td'>1-9</div>
                  <div className='td'>2858（全体の46.10%）</div>
                </div>
              </div>
            </div>

            <div className='full-label'>
              <div className='label'>雇った書店員数</div>
              <div className='wrap'>
                <div className='cell head'>
                  <div className='td'>書店員数</div>
                  <div className='td'>店長数</div>
                </div>
                <div className='cell body'>
                  <div className='td'>370-379</div>
                  <div className='td'>1（全体の0.003%）</div>
                </div>
                <div className='cell body'>
                  <div className='td'>360-369</div>
                  <div className='td'>1（全体の0.003%）</div>
                </div>
                <div className='cell body'>
                  <div className='td'>270-279</div>
                  <div className='td'>1（全体の0.003%）</div>
                </div>
                <div className='cell body'>
                  <div className='td'>180-189</div>
                  <div className='td'>2（全体の0.006%）</div>
                </div>
                <div className='cell body'>
                  <div className='td'>170-179</div>
                  <div className='td'>1（全体の0.003%）</div>
                </div>
                <div className='cell body'>
                  <div className='td'>160-169</div>
                  <div className='td'>1（全体の0.003%）</div>
                </div>
                <div className='cell body'>
                  <div className='td'>140-149</div>
                  <div className='td'>4（全体の0.012%）</div>
                </div>
                <div className='cell body'>
                  <div className='td'>130-139</div>
                  <div className='td'>1（全体の0.003%）</div>
                </div>
                <div className='cell body'>
                  <div className='td'>120-129</div>
                  <div className='td'>4（全体の0.012%）</div>
                </div>
                <div className='cell body'>
                  <div className='td'>110-119</div>
                  <div className='td'>2（全体の0.006%）</div>
                </div>
                <div className='cell body'>
                  <div className='td'>100-109</div>
                  <div className='td'>3（全体の0.009%）</div>
                </div>
                <div className='cell body'>
                  <div className='td'>90-99</div>
                  <div className='td'>1（全体の0.003%）</div>
                </div>
                <div className='cell body'>
                  <div className='td'>80-89</div>
                  <div className='td'>3（全体の0.009%）</div>
                </div>
                <div className='cell body'>
                  <div className='td'>70-79</div>
                  <div className='td'>11（全体の0.034%）</div>
                </div>
                <div className='cell body'>
                  <div className='td'>60-69</div>
                  <div className='td'>18（全体の0.056%）</div>
                </div>
                <div className='cell body'>
                  <div className='td'>50-59</div>
                  <div className='td'>34（全体の0.106%）</div>
                </div>
                <div className='cell body'>
                  <div className='td'>40-49</div>
                  <div className='td'>59（全体の0.184%）</div>
                </div>
                <div className='cell body'>
                  <div className='td'>30-39</div>
                  <div className='td'>128（全体の0.399%）</div>
                </div>
                <div className='cell body'>
                  <div className='td'>20-29</div>
                  <div className='td'>425（全体の1.325%）</div>
                </div>
                <div className='cell body'>
                  <div className='td'>10-19</div>
                  <div className='td'>7045（全体の21.958%）</div>
                </div>
                <div className='cell body'>
                  <div className='td'>1-9</div>
                  <div className='td'>24339（全体の75.860%）</div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/app/components/ModalResult/ModalResult.jsx